/* istanbul ignore file */
import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";
import { ILocale } from "infrastructure/localization";
import { IIndustry } from "ui/shared/models/common";

import { ITranslation, ITermDictionarySearchQuery } from "./TermDictionary.state";

const getApiProvider = () => {
  const createTermDictionarySearchRequest = (query: ITermDictionarySearchQuery) => {
    const params = new URLSearchParams();

    query.locale && params.append("locale", query.locale.localeIdentifier);
    query.bilingual && params.append("locale", "en");
    query.industry && params.append("industry", query.industry.isiCv4Code);
    query.keyword && params.append("keyword", query.keyword);

    return { params };
  };

  return {
    getLocales: async (filter?: string) => (await getClientFor(mainApi.name).get<ILocale[]>("/term-translations/locales", { params: { filter } })).data,
    getIndustries: async (locale: string, filter?: string) =>
      (await getClientFor(mainApi.name).get<IIndustry[]>("/term-translations/industries", { params: { filter, locale } })).data,
    getTranslations: async (query: ITermDictionarySearchQuery) =>
      (await getClientFor(mainApi.name).get<ITranslation[]>("/term-translations", createTermDictionarySearchRequest(query))).data,
    exportDictionaryTermTranslations: async (query: ITermDictionarySearchQuery) =>
      await getClientFor(mainApi.name).get("/term-translations/export-dictionary", { ...createTermDictionarySearchRequest(query), responseType: "blob" })
  };
};

export const termDictionaryApi = getApiProvider();
